import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isNotNullOrEmpty } from "utils";

const Equipment = ({ equipment, id }) => {
	const equipmentItem =
		isNotNullOrEmpty(equipment) &&
		equipment.find((e) => e.id === id);

	return <>{equipmentItem?.equipment || "-"}</>;
};

Equipment.propTypes = {
	equipment: PropTypes.array.isRequired,
	id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ equipment }) => ({
	equipment: equipment.data,
});

export default connect(mapStateToProps)(Equipment);

